import Select from 'react-select';
import { styled } from 'styled-components';
import type { JSX } from 'react';
import type { CommentingSortType } from '../Store/MediaStore';
import { useMediaStore, MediaStoreSelectors, commentingSorts } from '../Store/MediaStore';

// TODO this grid-area value should change based on media query
const ChooserContainer = styled.div`
  grid-area: SortAndFilter;
  width: 125px;
`;

const SELECT_OPTIONS = [
  { label: 'Timecode', value: 'timecode' },
  { label: 'Newest', value: 'newest' },
  { label: 'Oldest', value: 'oldest' },
];

const getDefaultValue = (commentingSort: CommentingSortType) => {
  if (commentingSort === commentingSorts.newest) {
    return SELECT_OPTIONS[1];
  }
  if (commentingSort === commentingSorts.oldest) {
    return SELECT_OPTIONS[2];
  }

  return SELECT_OPTIONS[0];
};

export const CommentsSortChooser = (): JSX.Element => {
  const commentingSort = useMediaStore(MediaStoreSelectors.getCommentingSort);
  const { setCommentingSort } = useMediaStore(MediaStoreSelectors.getActions);
  const defaultValue = getDefaultValue(commentingSort);

  const onChangeSelection = ({ value }: { value: string }) => {
    let orderBy = commentingSorts.timecode;
    switch (value) {
      case 'timecode':
        break;
      case 'newest':
        orderBy = commentingSorts.newest;
        break;
      case 'oldest':
        orderBy = commentingSorts.oldest;
        break;
      default:
        break;
    }

    setCommentingSort(orderBy);
  };

  return (
    <ChooserContainer>
      <Select
        aria-label="Comments Sort Chooser"
        components={{
          IndicatorSeparator: null,
        }}
        isSearchable={false}
        options={SELECT_OPTIONS}
        onChange={onChangeSelection}
        placeholder={null}
        defaultValue={defaultValue}
      />
    </ChooserContainer>
  );
};
